(() => {
  const pageContext = () => ({
    page_path: window.location.pathname,
    page_title: document.title,
    template: document.querySelector('#MainContent')?.dataset.template || '',
  });

  const publish = (eventName, eventData = {}) => {
    const detail = { ...pageContext(), ...eventData };
    document.dispatchEvent(new CustomEvent(eventName, { detail }));

    const shopifyPublish = window.Shopify?.analytics?.publish;
    if (typeof shopifyPublish !== 'function') return;

    try {
      Promise.resolve(shopifyPublish.call(window.Shopify.analytics, eventName, detail)).catch(() => {});
    } catch (_) {}
  };

  const linkPlacement = (link) => {
    if (link.matches('.bf-whatsapp')) return 'floating_button';
    if (link.closest('[data-bf-purchase-planner]')) return 'product_planner';
    if (link.closest('header')) return 'header';
    if (link.closest('footer')) return 'footer';
    return 'content';
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }

    if (!['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) return;

    publish('bimmerfit:whatsapp_click', {
      placement: linkPlacement(link),
      link_label: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120),
    });
  }, true);

  window.BimmerfitConversion = Object.freeze({ publish });
})();
